import { CookieSettings } from "../../../library/ts/html/cookies/CookieSettings";
import { DocSearchSettings } from "./DocSearchSettings";

export class RokojoirCookieSettings extends CookieSettings
{
  ds = new DocSearchSettings();
  editing = "";
  mainActiveIndex = 0;
  

  static create()
  {
    let rcs = new RokojoirCookieSettings();
    CookieSettings.setName( rcs, "rj-settings" );
    return rcs;
  } 
}